<template>
  <div>
    <div class="border-b border-gray-200">
      <nav class="flex justify-center" aria-label="Tabs">
        <div
          v-for="tab in tabs"
          :key="tab.value"
          :class="[
            'border-b-2 w-full text-center',
            modelValue === tab.value ? 'border-[#2F7F91]' : 'border-transparent'
          ]"
        >
          <button
            :data-testid="tab.testId"
            @click="selectTab(tab.value)"
            :class="[
              'py-4 px-2 transition-colors focus:outline-none w-full h-full',
              modelValue === tab.value
                ? 'text-gray-900 font-bold'
                : 'text-gray-500 hover:text-gray-700'
            ]"
          >
            {{ tab.label }}
          </button>
        </div>
      </nav>
    </div>

    <div v-if="hasSlots" class="mt-8">
      <Transition name="fade" mode="out-in">
        <div :key="modelValue">
          <slot :name="modelValue"></slot>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, useSlots } from 'vue'

export interface TabItem {
  label: string
  value: string
  testId?: string
}

defineProps<{
  modelValue: string
  tabs: TabItem[]
}>()

const slots = useSlots()
const hasSlots = computed(() => Object.keys(slots).length > 0)

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const selectTab = (value: string) => {
  emit('update:modelValue', value)
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition:
    opacity 0.25s ease-out,
    transform 0.25s ease-out;
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
